import styled, { css } from 'styled-components';

export const ContentWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 24px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 16px;
    }
  `}
`;

export const SectionContainer = styled.div`
  ${({ theme, $padding }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    padding: ${$padding || '24px'};
    flex: 1;
    min-width: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 16px;
    }
  `}
`;

export const StatsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 32px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      align-items: stretch;
      gap: 24px;
    }
  `}
`;

export const StatItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
    min-width: 314px;
    padding: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      min-width: auto;
      width: 100%;
      padding: 12px 8px;
    }
  `}
`;

export const StatContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

export const StatDivider = styled.div`
  ${({ theme }) => css`
    width: 1px;
    height: 100px;
    background-color: #dfe2eb;
    align-self: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: none;
    }
  `}
`;

export const StatsButtonWrapper = styled.div`
  ${({ theme }) => css`
    margin-left: auto;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin-left: 0;
      width: 100%;
    }
  `}
`;

export const TrendingPostContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 40px;
    padding: 24px;
    border-radius: 16px;
    background-color: #f5f5f5;
    height: 332px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      align-items: center;
      gap: 24px;
      height: auto;
      padding: 24px 16px;
    }
  `}
`;

export const TrendingPostImageWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
      max-width: 280px;
    }
  `}
`;

export const TrendingPostContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 40px;
    max-width: 668px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 24px;
      width: 100%;
    }
  `}
`;

export const MainContentContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: 24px;
    flex: 1;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      flex-direction: column;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 16px;
    }
  `}
`;

export const RecentCampaignsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 32px;
    flex: 1;
    min-width: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 24px;
    }
  `}
`;

export const CampaignsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const CampaignItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 16px;
    padding: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 12px 8px;
      gap: 12px;
    }
  `}
`;

export const CampaignInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

export const SideCardsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 381px;
    flex-shrink: 0;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    padding: 24px;
    gap: 32px;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      width: 100%;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 16px;
      gap: 24px;
    }
  `}
`;

export const ActionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
`;
